import "./Dashboard.css";
import {
  getAllBuyerRequirementApi
} from "../../services/buyerRequirement/buyerRequirement.service";
import { getAllInventory } from "../../services/Inventory/Inventory.service";
import { getAllSellers } from "../../services/Users/User.service";
import { getAllInvoices } from "../../services/orderList/order.service";
import {
  FileText,
  Truck,
  Users,
  Box,
} from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminOverview = () => {
const [pendingDeliveries, setPendingDeliveries] = useState(0);
  const [requirements, setRequirements] = useState<any[]>([]);
  const [inventory, setInventory] = useState<any[]>([]);
  const [inventoryCount, setInventoryCount] = useState(0);
  const [sellerCount, setSellerCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ================= REQUIREMENTS =================
  const fetchRequirements = async () => {
    try {
      setLoading(true);
      const res = await getAllBuyerRequirementApi();

      if (res?.data) {
        setRequirements(res.data);

      }
    } catch (error) {
      console.error("Error fetching requirements", error);
    } finally {
      setLoading(false);
    }
  };


  const fetchPendingDeliveries = async () => {
  try {
    const res = await getAllInvoices();

    setPendingDeliveries(
      res?.data?.pendingDeliverys || 0
    );
  } catch (error) {
    console.error("Error fetching pending deliveries", error);
    setPendingDeliveries(0);
  }
};

const fetchInventory = async () => {
  try {
    const res = await getAllInventory();

    // 🔥 handle all possible cases
    const inventoryArray =
      res?.data?.data ||   // axios wrapped response
      res?.data ||         // direct API
      [];

    if (Array.isArray(inventoryArray)) {
      setInventory(inventoryArray);
      setInventoryCount(inventoryArray.length);
    } else {
      setInventory([]);
      setInventoryCount(0);
    }

  } catch (error) {
    console.error("Error fetching inventory", error);
    setInventory([]);
    setInventoryCount(0);
    
  }
};

  // ================= SELLERS =================
  const fetchSellers = async () => {
    try {
      const res = await getAllSellers();

      if (res) {
        setSellerCount(res.length);
      }

    } catch (error) {
      console.error("Error fetching sellers", error);
    }
  };

  useEffect(() => {
    fetchRequirements();
    fetchInventory();
    fetchSellers();
      fetchPendingDeliveries();
  }, []);

  // ================= FILTERS =================
  const activeRequirementsCount = requirements.filter(
    (r) => r.requirmentStatus !== "Cancelled"
  ).length;

  const latestRequirements = [...requirements]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 5);

  const latestInventory = [...inventory]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 5);

  return (
    <div className="dashboard-root">

      {/* ===== TOP STATS ===== */}
      <div className="stats-row">

        <div className="stat-box active">
          <div>
            <p className="stat-title">Active Requirements</p>
            <h2>{activeRequirementsCount}</h2>
          </div>
          <FileText />
        </div>

        <div className="stat-box">
          <div>
            <p className="stat-title">Total Inventory</p>
            <h2>{inventoryCount}</h2>
          </div>
          <Box />
        </div>

        <div className="stat-box">
          <div>
            <p className="stat-title">Pending Deliveries</p>
           <h2>{pendingDeliveries}</h2>
          </div>
          <Truck />
        </div>

        <div className="stat-box">
          <div>
            <p className="stat-title">Verified Sellers</p>
            <h2>{sellerCount}</h2>
          </div>
          <Users />
        </div>

      </div>

      {/* ===== MIDDLE ===== */}
      <div className="middle-row">

        {/* ===== REQUIREMENTS LIST ===== */}
        <div className="panel">
          <div className="panel-header">
            <div>
              <h3>Recent Requirements</h3>
              <p>Latest buyer requests</p>
            </div>
            <span
              className="view-all"
              onClick={() => navigate("/buyerRequirement/list")}
            >
              View All ↗
            </span>
          </div>

          {latestRequirements.map((item) => (
            <div className="list-item" key={item.id}>
              <div>
                <h4>{item.category_name || "Item"}</h4>
                <p>
                  {item?.buyerDetails?.firstName || "User"} ·{" "}
                  {item?.metalTypeDetails?.name || "-"} ·{" "}
                  {item.weight}
                </p>
              </div>

              <span className={`badge ${item.requirmentStatus === "Matched"
                  ? "blue"
                  : item.requirmentStatus === "Delivered"
                    ? "green"
                    : item.requirmentStatus === "Cancelled"
                      ? "red"
                      : "yellow"
                }`}>
                {item.requirmentStatus}
              </span>
            </div>
          ))}

        </div>

        {/* ===== INVENTORY LIST ===== */}
        <div className="panel">
          <div className="panel-header">
            <div>
              <h3>Recent Inventory</h3>
              <p>Latest seller uploads</p>
            </div>
            <span
              className="view-all"
              onClick={() => navigate("/Inventory-list")}
            >
              View All ↗
            </span>
          </div>

          {latestInventory.map((item) => (
            <div className="list-item" key={item.id}>
              <div>
                <h4>{item?.item?.articleName || "Item"}</h4>
                <p>
                  {item?.buyers_sellers_detail?.businessName || "Seller"} ·{" "}
                  {item?.item?.MetalTypeName || "-"} ·{" "}
                  {item.totalWeight}
                </p>
              </div>

              <span className={`dot ${item.isAvailable ? "green" : "red"}`}>
                {item.isAvailable ? "Available" : "Sold"}
              </span>
            </div>
          ))}

        </div>

      </div>

    </div>
  );
};

export default AdminOverview;